import PollOverlay from './PollOverlay';
import PollOverlayContainer from './PollOverlay.container';
export default PollOverlayContainer(PollOverlay);
